/* eslint-disable eqeqeq */

/********************************************************************************
 * @author       Tech.us
 * @module       AuthModule
 * @name         Logout
 * @description  Component for logging out of the application
 * @copyright    Tech.us  
 * @Createdon    Apr 2025
 * @since        1.0
 *********************************************************************************/

import React, { useState, useEffect} from 'react'
import { useDispatch, useSelector } from "react-redux";

import { useNavigate, Navigate, useLocation } from 'react-router-dom';
import Loader from '../../genriccomponents/loaders/RedLoader';
import { LogOutUser } from '../../services/techus-services';
const Logout = (props) => {
 
  const [loader ,setLoader ] =useState(true) 
  const navigate = useNavigate()
 
  const getBrowserInfo = () => {
    const userAgent = navigator.userAgent;
    let browserInfo = {};
  
    // Detect browser name and version
    if (/Firefox[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Firefox';
      browserInfo.version = RegExp.$1;
    } else if (/Chrome[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Chrome';
      browserInfo.version = RegExp.$1;
    } else if (/Edge[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Edge';
      browserInfo.version = RegExp.$1;
    } else if (/Safari[\/\s](\d+\.\d+)/.test(userAgent)) {
      browserInfo.name = 'Safari';
      browserInfo.version = RegExp.$1;
    } else {
      browserInfo.name = 'Unknown';
      browserInfo.version = 'Unknown';
    }
  
    return browserInfo;
  };
  
  const getOsInfo = () => {
    const userAgent = navigator.userAgent;
    let osInfo = {};
  
    // Detect OS name and version
    if (/(Windows NT ([\d\.]+))/.test(userAgent)) {
      osInfo.name = 'Windows';
      const fullVersion = RegExp.$1;
      const versionParts = fullVersion.split(' ').pop().split('.'); // Split by spaces and dots
      osInfo.version = versionParts[0]; // Get major version (e.g., 10)
    } else if (/(Mac OS X [\d_]+)/.test(userAgent)) {
      osInfo.name = 'Mac OS X';
      osInfo.version = RegExp.$1.replace(/_/g, '.');
    } else if (/(Linux [a-z0-9_\.\/-]+)/i.test(userAgent)) {
      osInfo.name = 'Linux';
      osInfo.version = 'Unknown'; // Not easy to determine specific Linux version from userAgent
    } else {
      osInfo.name = 'Unknown';
      osInfo.version = 'Unknown';
    }
  
    return osInfo;
  };
  
  // Usage example to get OS and browser info
  const osInfo = getOsInfo();
  const browserInfo = getBrowserInfo();
  
  // Example of how to use these values in an API request header
  const headers = {
    osName: osInfo.name,
    osVersion: osInfo.version,
    browserName: browserInfo.name,
    browserVersion: browserInfo.version,
  };
 


    // delete the token by userid
    useEffect(() => {
      const params = new URLSearchParams(headers);
      const authLogOut = async()=>{
        const response = await LogOutUser(params)
        if(response.valid){
          localStorage.removeItem("user_access_token");
          localStorage.clear();
          setLoader(false)
          // navigate("/login");
        }else{
          setLoader(false)
          return false
        } 
      }
       authLogOut()
      },[])
      
     return (
        <div>
          { loader ? (<Loader />) : null}
        </div>
    );
}

export default Logout;